import { FormRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useRef } from "react";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";

import { Button } from "@progress/kendo-react-buttons";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { CustomAppDialog } from "../../components/dialog/Dialog";
import { LoadingPanel } from "../../components/layout/Loading";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { ImCross } from "react-icons/im";
import { closeMinaReceiptOrderSelectionDialog } from "./minaReceiptSlice";

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

interface SelectDialogProps {
  formRenderProps: FormRenderProps;
}

const MinaReceiptOrderSelectionDialog = ({
  formRenderProps,
}: SelectDialogProps) => {
  const minaPendingOrderList = useAppSelector(
    (state) => state.minareceipt.MinaPendingOrderList,
  );
  const MinaReceiptOrderSelectionDialog = useAppSelector(
    (state) => state.minareceipt.MinaReceiptOrderSelectionDialog,
  );
  const MinaReceiptOrderItemIndex = useAppSelector(
    (state) => state.minareceipt.MinaReceiptOrderItemIndex,
  );

  const dispatch = useAppDispatch();

  const loading = useAppSelector((state) => state.minareceipt.loading);
  const gridRef = useRef<any>(null);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All"
        ? minaPendingOrderList.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  // const MyImageCommandCell = (props: GridCellProps) => {
  //   const handlClickItem = (image: string) => {
  //     if (image && typeof image === "string") {
  //       window.open(image);
  //     }
  //   };
  //   if (props.dataItem?.image === null) {
  //     return (
  //       <div
  //         style={{
  //           display: "flex",
  //           flexDirection: "column",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           height: "50px",
  //         }}
  //       >
  //         <MdOutlineImageNotSupported style={{ fontSize: "30px" }} />
  //         <p style={{ margin: 0, fontSize: "12px" }}>No Image!</p>
  //       </div>
  //     );
  //   }
  //   return (
  //     <td className="action-td main-image">
  //       <div
  //         style={{
  //           position: "relative",
  //           border: "1px dotted lightgrey",
  //           borderRadius: "5px",
  //           height: "50px",
  //           overflow: "hidden",
  //         }}
  //       >
  //         <img
  //           className="product-image"
  //           src={props.dataItem?.image_name}
  //           alt=""
  //           style={{
  //             height: "100%",
  //             width: "100%",
  //             objectFit: "cover",
  //             borderRadius: "5px",
  //           }}
  //         />
  //         <div className="image-view">
  //           <FaRegEye
  //             style={{
  //               color: "white",
  //               height: 24,
  //               width: 24,
  //               cursor: "pointer",
  //             }}
  //             onClick={() => handlClickItem(props.dataItem?.image_name)}
  //           />
  //         </div>
  //       </div>
  //     </td>
  //   );
  // };

  const MyEditCommandCell = (props: any) => {
    const handleSelectOrder = async (order_id: number) => {
      const getOrderNowiseData = async () => {
        try {
          const updateField = (field: any, value: any) =>
            formRenderProps?.onChange(
              `mina_receipt_order.${MinaReceiptOrderItemIndex}.${field}`,
              { value },
            );
          updateField("order_no", props.dataItem?.order_id);
          updateField("order_id", props.dataItem?.order_id);
          updateField("item_id", props.dataItem?.item_id);
          updateField("item_description", props.dataItem?.Remark);
          updateField("issue_weight", props.dataItem?.weight);
        } catch (error) {
          console.error(error);
        }
      };
      if (order_id) {
        await getOrderNowiseData();
        dispatch(closeMinaReceiptOrderSelectionDialog());
      }
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <Button
          type="button"
          fillMode="solid"
          themeColor={"primary"}
          size="small"
          title="Select Order"
          onClick={() => handleSelectOrder(props.dataItem?.order_id)}
        >
          Select
        </Button>
      </td>
    );
  };
  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 4 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      <CustomAppDialog open={MinaReceiptOrderSelectionDialog}>
        <div style={{ width: "70vw", minHeight: "30vh" }}>
          {loading && <LoadingPanel gridRef={gridRef} />}
          <GridLayout gap={{ rows: 10, cols: 10 }}>
            <GridLayoutItem
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography.h4>{"Select Order"}</Typography.h4>

              <ImCross
                style={{
                  color: "white",
                  background: "red",
                  borderRadius: "50%",
                  padding: "5px",
                  fontSize: "24px",
                }}
                onClick={() => dispatch(closeMinaReceiptOrderSelectionDialog())}
              />
            </GridLayoutItem>

            <GridLayoutItem style={{ overflow: "hidden" }}>
              <KendoGrid
                className="selection-dialog responsive-table"
                // dataItemKey={DATA_ITEM_KEY}
                style={{ maxHeight: "calc(100vh - 152px)" }}
                filterable={true}
                filter={filter}
                data={
                  filter
                    ? filterBy(minaPendingOrderList, filter).slice(
                        page.skip,
                        page.take + page.skip,
                      )
                    : minaPendingOrderList.slice(
                        page.skip,
                        page.take + page.skip,
                      )
                }
                total={minaPendingOrderList.length}
                onFilterChange={handleFilterChange}
                skip={page.skip}
                take={page.take}
                pageable={{
                  buttonCount: 5,
                  pageSizes: [5, 10, 15, "All"],
                  pageSizeValue: pageSizeValue,
                  type: "input",
                }}
                onPageChange={pageChange}
                cells={{
                  headerCell: HeaderCustomCell,
                  data: MyDataCustomCell,
                }}
              >
                {/* <Column
                  field="image_name"
                  title="Image"
                  width={100}
                  cells={{
                    data: MyImageCommandCell,
                  }}
                  filterable={false}
                /> */}
                <Column
                  field="order_no"
                  title="Order No"
                  width={100}
                  filterable={false}
                  cells={{
                    data: (props: any) => (
                      <td>
                        <div style={{ color: "green" }}>
                          <strong>
                            {props.dataItem?.order_no}
                            {props.dataItem?.ordersub_no
                              ? `.${props.dataItem?.ordersub_no}`
                              : ""}
                          </strong>
                        </div>
                      </td>
                    ),
                  }}
                />
                {/* <Column width={200} field="order_id" title="Order ID" /> */}
                <Column width={200} field="karigar_name" title="Karigar Name" />
                <Column width={200} field="item_name" title="Product Name" />
                <Column width={200} field="weight" title="Weight (gm)" />
                <Column width={130} field="issue_date" title="Issue Date" />
                <Column
                  width={130}
                  field="approx_delivery_date"
                  title="Delivery Date"
                />
                <Column
                  field="order_no"
                  title="Actions"
                  cells={{ data: MyEditCommandCell }}
                  width={"90px"}
                  filterable={false}
                  locked={true}
                />
              </KendoGrid>
            </GridLayoutItem>
          </GridLayout>
        </div>
      </CustomAppDialog>
    </>
  );
};

export default MinaReceiptOrderSelectionDialog;
